import React, { useEffect, useState } from 'react'
import Topbar from '../layout/Topbar'
import Navbar from '../layout/Navbar'
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import dayjs from '../../utils/dayjs';
import { getErrorMessage, logError } from '../../utils/errorHandler';
import { RotatingLines } from 'react-loader-spinner';

const Profile = () => {
    const location = useLocation();
    // const book = location.state.book;

    const [user, setUser] = useState('');
    const [sessions, setSessions] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    const [kode, setKode] = useState('');
    const [isDisabled, setDisabled] = useState(true);
    const [msg, setMsg] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        getProfile();
        getSessions();
    }, []);

    const getProfile = async () => {
        try {
            const res = await api.get('/users');
            //console.log(res.data)
            setUser(res.data.user);
        } catch (error) {
            logError('Gagal memuat profil:', error);
            setMsg(getErrorMessage(error, 'Gagal memuat profil.'));
        }
    }

    const getSessions = async (e) => {
        try {
            const res = await api.post('/sessions');
            setSessions(res.data.sessions)
            console.log(res.data.sessions)
        } catch (error) {
            logError('Gagal memuat sesi:', error);
            setMsg(getErrorMessage(error, 'Gagal memuat daftar sesi.'));
        }
    }

    const showModalDelete = ()=>{
        setKode('');
        setModalDelete(true);
    }

    const endSession = async (sessionId) => {
        console.log(sessionId);
        try {
            await api.post('/session/end', {
                session_id: sessionId
            })
            getSessions()
        } catch (error) {
            logError('Gagal mengakhiri sesi:', error);
            setMsg(getErrorMessage(error, 'Gagal mengakhiri sesi.'));
        }
    }

    const handleChangeKode = (kode) => {
        setKode(kode)
        setDisabled(true)
        if (kode === 'DELETE') {
            setDisabled(false)
        }
    }

    const deleteAccount = async () => {
        setLoading(true);
        setDisabled(true);
        try {
            await api.post('/delete');
            navigate('/logout');
        } catch (error) {
            logError('Gagal menghapus akun:', error);
            setMsg(getErrorMessage(error, 'Gagal menghapus akun.'));
        } finally {
            setLoading(false);
            setDisabled(false);
        }
    }

    const getDate = (string) => {
        const m = dayjs.utc(string).local();
        return m.format('[Last active] D MMM [at] HH:mm');
    }

    return (
        <div>
            <Topbar
                title={'User Profile'}
                back={()=>navigate(-1)}
            />
            <div className='container p-5'>

                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">
                        {msg && <p className="has-text-danger mb-4">{msg}</p>}
                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Account</p>
                            </header>
                            <div className='card-content'>
                                <p className='is-size-6'>{user.name}</p>
                                <p className='is-size-6'>{user.email}</p>
                            </div>
                        </div>
                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Devices</p>
                            </header>
                            <div className='card-content'>

                                {sessions.map((item, index) => (
                                    <div key={index} className='' >
                                        <div className='is-clearfix'>
                                            <div className='is-pulled-left'>
                                                <p className='is-size-6'>
                                                    {item.device}
                                                    <span className={item.current ? 'is-size-6' : 'is-invisible'}> (this device) </span>
                                                </p>
                                                <p className='is-size-7'> {getDate(item.updated)}</p>

                                            </div>

                                            <div className={`is-pulled-right ${item.current ? 'is-invisible' : ''}`}>
                                                <button className="has-text-grey-light" onClick={() => endSession(item.id)}>
                                                    <i className="fa fa-window-close is-size-3"></i>
                                                </button>
                                            </div>

                                        </div>
                                        <hr />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button className='button is-fullwidth has-text-danger' onClick={() => navigate('/logout')}>Logout</button>
                        <p className='has-text-centered mt-6'>
                            <span className='has-text-danger' onClick={() => { showModalDelete() }}>Delete Account</span>

                        </p>

                        <div className={`modal p-5 ${modalDelete ? 'is-active' : ''}`}>
                            <div className="modal-background"></div>
                            <div className="modal-content card">
                                <header className='card-header'>
                                    <p className="card-header-title">Delete Account</p>
                                    <button className="card-header-icon" onClick={() => setModalDelete(!modalDelete)}>
                                        <i className="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                </header>
                                <div className='card-content'>
                                    <p>
                                        Proses delete account ini akan menghapus seluruh data yang Anda buat seperti buku kas, transaksi,
                                        dan semua yang berkaitan dengan akun ini secara permanen, kecuali data di dalam buku kas dimana Anda sebagai member.
                                        Anda masih bisa mendaftar kembali menggunakan email yang lain.
                                    </p>
                                    <p className='mt-5'>
                                        ketik "DELETE" pada kotak berikut untuk melanjutkan.
                                    </p>
                                    <div className="field mt-2">
                                        {/* <label className="label">Email</label> */}
                                        <div className="controls">
                                            <input type="text" className="input" placeholder=''
                                                value={kode} onChange={(e) => handleChangeKode(e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='has-text-centered'>
                                        <RotatingLines
                                            visible={isLoading}
                                            height="20"
                                            width="20"
                                            strokeColor="gray"
                                            strokeWidth="5"
                                            animationDuration="0.75"
                                            ariaLabel="rotating-lines-loading"
                                        />
                                    </div>
                                </div>
                                <footer className='card-footer'>
                                    <button className='card-footer-item' onClick={() => setModalDelete(!modalDelete)}>Batal</button>
                                    <button className='card-footer-item has-text-danger'
                                        onClick={() => deleteAccount()} disabled={isDisabled}>
                                        DELETE
                                    </button>
                                </footer>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile
